export const alternateKeyMap = Object.freeze({
  'left': 'leftarrow',
  'right': 'rightarrow',
  'up': 'uparrow',
  'down': 'downarrow'
});